/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (motion effect) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		wiggle: {
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			tip: 'Wiggle noise',
			unit: '%',
			kind: 'range',
			tooltip: {
				heading: 'Wiggle Noise',
				body: 'Animate the initial noise to create a dynamic, ever shifting image.',
			},
		},
		pan: {
			type: 'integer',
			minimum: -50,
			maximum: 50,
			step: 1,
			initial: 0,
			label: 'Pan X',
			kind: 'range',
			tooltip: {
				heading: 'Noise Pan X',
				body: 'Shifts the noise pattern horizontally over time, creating a sideways drift in the diffusion output.',
			},
		},
		tilt: {
			type: 'integer',
			minimum: -50,
			maximum: 50,
			step: 1,
			initial: 0,
			label: 'Pan Y',
			kind: 'range',
			tooltip: {
				heading: 'Noise Pan Y',
				body: 'Shifts the noise pattern vertically over time, creating an upward or downward drift in the diffusion output.',
			},
		},
		temporal_smoothing: {
			type: 'integer',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 25,
			label: 'Temporal Smoothing',
			tip: 'Attention history across frames',
			unit: '%',
			kind: 'range',
			tooltip: {
				heading: 'Temporal Smoothing',
				body: 'How strongly each frame draws on the frames before it. Higher values hold the look steadier across frames.',
			},
		},
		interpolation: {
			type: 'boolean',
			initial: true,
			label: 'Frame Interpolation',
			tip: 'Interpolated in-between frames',
		},
		input_smoothing: {
			type: 'integer',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 25,
			label: 'Input Smoothing',
			tip: 'Damps small input changes',
			unit: '%',
			kind: 'range',
			tooltip: {
				heading: 'Input Smoothing',
				body: 'Holds back small changes in the source video, such as camera noise, while letting large movements through.',
			},
		},
		output_smoothing: {
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			label: 'Output Smoothing',
			tip: 'Frame blending',
			unit: '%',
			kind: 'range',
			icon: 'mo/ev_shadow',
			tooltip: {
				heading: 'Frame Blending',
				body: 'Blends consecutive frames together to create smoother transitions and reduce flickering in the output.',
			},
		},
	},
	primary: ['wiggle', 'temporal_smoothing'],
}
